import { render, staticRenderFns } from "./ShowPhotoModal.vue?vue&type=template&id=61d070e9&"
import script from "./ShowPhotoModal.vue?vue&type=script&lang=js&"
export * from "./ShowPhotoModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowPhotoModal.vue?vue&type=style&index=0&id=61d070e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VIcon,VImg,VProgressCircular,VRow})
